module.exports = __webpack_public_path__ + "d664201f/img/pdf-icon.79f04a36.svg";